import {
  getProfileActiveVouchers,
  getProfileHistoryVouchers,
} from '@/features/profile/profileActions';
import {
  activeVouchersProfileSelector,
  historyVouchersProfileSelector,
} from '@/features/profile/profileSelectors';
import { TransText } from '@/i18n/trans/text';
import BookingNoItems from '@/routes/account/layout/BookingNoItems';
import VoucherSummary from '@/routes/account/vouchers/VoucherSummary';
import { useDispatch, useSelector } from '@/store/utils';
import type { ProfileBookingTimeType } from '@/types/profile';
import { useEffect, type FC } from 'react';
import { toast } from 'react-toastify';

interface VouchersListProps {
  timeType: ProfileBookingTimeType;
}

const VouchersList: FC<VouchersListProps> = ({ timeType }) => {
  const dispatch = useDispatch();

  const isActive = timeType === 'active';

  const vouchers = useSelector(
    isActive ? activeVouchersProfileSelector : historyVouchersProfileSelector
  );

  useEffect(() => {
    if (!vouchers) {
      const fetchVouchers = async () => {
        try {
          await dispatch(
            isActive ? getProfileActiveVouchers() : getProfileHistoryVouchers()
          ).unwrap();
        } catch (error) {
          toast.error(
            <TransText
              i18nKey={
                isActive
                  ? 'errorFetchingActiveVouchers'
                  : 'errorFetchingHistoryVouchers'
              }
            />
          );
        }
      };
      fetchVouchers();
    }
  }, [dispatch, isActive, vouchers]);

  if (!vouchers?.items?.length) {
    return <BookingNoItems bookingType="vouchers" timeType={timeType} />;
  }

  return (
    <div className="h-full w-full">
      <div className="grid w-full grid-cols-1 gap-4 laptop:grid-cols-2">
        {vouchers.items.map((voucher) => (
          <VoucherSummary key={voucher.id} voucher={voucher} />
        ))}
      </div>
    </div>
  );
};

export default VouchersList;
